import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";

const FaqSection = ({ title = "Frequently Asked Questions", items, testId = "faq-section" }) => {
  if (!items || items.length === 0) return null;
  return (
    <section className="bg-white section-padding" data-testid={testId}>
      <div className="container-custom max-w-4xl">
        <h2 className="text-3xl font-semibold text-navy mb-8 font-heading text-center">
          {title}
        </h2>
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`q-${i}`}
              className="bg-slate-50 rounded-lg border border-slate-200 px-6"
              data-testid={`${testId}-item-${i}`}
            >
              <AccordionTrigger className="text-left text-navy font-semibold py-4 hover:no-underline hover:text-gold">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 pb-4">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
